import { useMutation, useQueryClient } from "react-query";
import { recalllInvoice } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";
import { toast } from "../../../../../components/toastNotification";

export const useRecallInvoiceDetails = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (ids: number[] | undefined) => recalllInvoice(ids),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["GetForReviewInvoices"]);

        toast.fire(
          "Success",
          "Vendor Invoice has been Recall successfully",
          "success"
        );
      },

      onError: () => {
        toast.fire(
          "Bulk Recall o fVendor Invoice failed",

          "Server Error: Cannot Recall Vendor Invoice",

          "error"
        );
      },
    }
  );

  return mutate;
};
